export const categories = [
  {
    id: `cat-1`,
    slug: `langman-yishi`,
    name: `浪漫仪式感`,
    description: `为婚姻注入仪式感，让每一天都充满爱的惊喜与期待。从纪念日创意到日常小浪漫，打造属于你们的甜蜜时光。`,
    icon: `ri-heart-line`,
  },
  {
    id: `cat-2`,
    slug: `goutong-jiqiao`,
    name: `沟通技巧`,
    description: `学会倾听与表达，让夫妻沟通不再充满误解与争吵。掌握高情商对话方法，让爱意在言语中流动。`,
    icon: `ri-chat-1-line`,
  },
  {
    id: `cat-3`,
    slug: `richang-guanai`,
    name: `日常关爱`,
    description: `爱藏在每一个细节里。从一杯温水到一句问候，学习如何在日常生活中让妻子感受到被珍视的温暖。`,
    icon: `ri-hand-heart-line`,
  },
  {
    id: `cat-4`,
    slug: `qinggan-jingying`,
    name: `情感经营`,
    description: `婚姻需要用心经营，如同花园需要悉心浇灌。掌握情感管理智慧，让夫妻感情历久弥新。`,
    icon: `ri-plant-line`,
  },
  {
    id: `cat-5`,
    slug: `fuqi-guanxi`,
    name: `夫妻关系`,
    description: `从角色定位到共同成长，从冲突化解到亲密升级。全方位提升夫妻关系质量，成为彼此最好的伴侣。`,
    icon: `ri-user-heart-line`,
  },
];